import { Component, OnInit,Output,EventEmitter, Input, forwardRef } from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

@Component({

    selector: 'aFormSelect,[aFormSelect]',
    templateUrl: './aFormSelect.component.html',
    styleUrls: ['./aFormSelect.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormSelectComponent, multi: true },
    ]
})
export class AFormSelectComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    @Input() options;
    @Output() changeValue: EventEmitter<any> = new EventEmitter();
    display=false;
    value;
    temp;
    _onChange = (value: any) => { };
    onChange(value: any) {
        if (value == "") {
            this.value = null;
            this.temp='';
            this.changeValue.emit(null);
            this._onChange('');
        } else {
            this.value = value;
            this.temp=value;
            
            this.changeValue.emit(value);
            this._onChange(value);
        }

    };
    height(){
        var h = $(window).height()-200;
        return h;
    }

    getLabel() {
        if (this.value && this.value._id && this.options) {
            let option:Array<any> =this.options.filter(x=> x._id === this.value._id);
            if(option.length >0){
                return option[0].label;
            }
        }
        return "";
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this.value = value;
    }

    constructor(public rootService:RootService) {
        this.temp = "";
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormSelect/aFormSelect.component.ts